import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ContractorBadge } from "@/components/contractor/ContractorBadge";

const BadgeInfo = () => {
  const breadcrumbItems = [
    { label: "For Pros", href: "/for-pros" },
    { label: "Trust Badge" }
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Home Pros OKC Trust Badge - For Service Professionals",
    "description": "Learn how to showcase your trusted status with the Home Pros OKC Trust Badge. Display your commitment to quality service and build customer trust."
  };

  return (
    <div className="min-h-screen">
      <SEO 
        title="Trust Badge Information - For Service Professionals | Home Pros OKC"
        description="Learn how to showcase your trusted status with the Home Pros OKC Trust Badge. Display your commitment to quality service and build customer trust."
        canonicalUrl="https://homeprosokc.com/badge-info"
        schema={schema}
      />
      
      <div className="container mx-auto px-4 py-8">
        <Breadcrumbs items={breadcrumbItems} />
        
        <div className="max-w-3xl mx-auto space-y-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-4">Home Pros OKC Trust Badge</h1>
            <p className="text-lg text-muted-foreground">
              Display this badge on your website to build trust with potential customers
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-2xl font-semibold mb-4">Why Display the Trust Badge?</h2>
            <ul className="space-y-3 list-disc pl-6">
              <li>Instantly demonstrate your credibility as a verified service provider</li>
              <li>Show potential customers that you're trusted by Oklahoma City's leading home service platform</li>
              <li>Build trust with customers who recognize the Home Pros OKC brand</li>
              <li>Stand out from competitors who haven't earned trusted status</li>
            </ul>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-2xl font-semibold mb-4">Sample Badge</h2>
            <div className="max-w-sm mx-auto">
              <ContractorBadge
                name="Sample Company"
                serviceType="Service Provider"
                pageUrl="/badge-info"
                showEmbedCode={false}
              />
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-2xl font-semibold mb-4">How to Add the Badge to Your Website</h2>
            <div className="space-y-4">
              <p>Adding the Trust Badge to your website is simple:</p>
              <ol className="list-decimal pl-6 space-y-2">
                <li>Copy the embed code from your contractor profile page</li>
                <li>Paste the code into your website's HTML where you want the badge to appear</li>
                <li>The badge will automatically display with your company name and trusted status</li>
              </ol>
              <div className="bg-blue-50 p-4 rounded-md mt-4">
                <p className="text-sm text-blue-800">
                  <strong>Pro Tip:</strong> Place the badge in a prominent location, such as your homepage or service pages, 
                  where potential customers can easily see your trusted status.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BadgeInfo;